import React from "react";

function PromotionIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="10 10 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.41 19.58L20.41 10.58C20.035 10.2081 19.5281 9.99958 19 10H12C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12V19C9.99979 19.2639 10.0518 19.5253 10.1531 19.769C10.2543 20.0127 10.4028 20.2339 10.59 20.42L19.59 29.42C19.965 29.7919 20.4719 30.0004 21 30C21.5296 29.9978 22.0367 29.7856 22.41 29.41L29.41 22.41C29.7856 22.0367 29.9978 21.5296 30 21C30.0002 20.7361 29.9482 20.4747 29.8469 20.231C29.7457 19.9873 29.5972 19.7661 29.41 19.58ZM21 28L12 19V12H19L28 21M14.5 13C14.7967 13 15.0867 13.088 15.3334 13.2528C15.58 13.4176 15.7723 13.6519 15.8858 13.926C15.9994 14.2001 16.0291 14.5017 15.9712 14.7926C15.9133 15.0836 15.7704 15.3509 15.5607 15.5607C15.3509 15.7704 15.0836 15.9133 14.7926 15.9712C14.5017 16.0291 14.2001 15.9994 13.926 15.8858C13.6519 15.7723 13.4176 15.58 13.2528 15.3334C13.088 15.0867 13 14.7967 13 14.5C13 14.1022 13.158 13.7206 13.4393 13.4393C13.7206 13.158 14.1022 13 14.5 13Z"
        fill="#667085"
      />
    </svg>
  );
}

export default PromotionIcon;
